import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of strings as `lines`.
// mode="load" animates on mount (for above-the-fold hero); default animates on scroll.
export const MaskReveal = ({ lines, className = "", delay = 0, stagger = 0.12, once = true, mode = "scroll" }) => {
  const anim =
    mode === "load"
      ? { animate: { y: "0%" } }
      : { whileInView: { y: "0%" }, viewport: { once, margin: "-8% 0px" } };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em]">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            {...anim}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Generic fade/slide up on scroll into view.
export const Reveal = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);
